/* eslint-disable camelcase */

import Icon from 'app/components/partials/icon';
import PropTypes from 'prop-types';
import React from 'react';

const BYTE_BASE = 1024;
const KILO_BYTE = 1024;
const MEGA_BYTE = KILO_BYTE * BYTE_BASE;
const GIGA_BYTE = MEGA_BYTE * BYTE_BASE;

class FileDownload extends React.Component {
    get fileInfo() {
        const bytes = this.props.filesize;
        const extension = this.props.extension.toUpperCase();

        if ((bytes >= KILO_BYTE) && (bytes < MEGA_BYTE)) {
            return `${Math.round(bytes / KILO_BYTE)}KB ${extension}`;
        } else if ((bytes >= MEGA_BYTE) && (bytes < GIGA_BYTE)) {
            return `${Math.round(bytes / MEGA_BYTE)}MB ${extension}`;
        } else if (bytes > GIGA_BYTE) {
            return `${Math.round(bytes / GIGA_BYTE)}GB ${extension}`;
        }

        return `${bytes}B ${extension}`;
    }

    render() {
        const { display_name, file, filename } = this.props;
        const fileInfo = this.fileInfo;

        return (
            <section className="content-section">
                <div className="file-download || constrain-width">
                    <div className="file-download-inner">
                        <div className="file-download-details">
                            <span className="file-download-title">{display_name || filename}</span>
                            <span className="file-download-info">{fileInfo}</span>
                        </div>
                        <a
                            className="file-download-link || button alternative"
                            href={file}
                            download={file}
                            target="_blank" // eslint-disable-line react/jsx-no-target-blank
                            title="Download" rel="noreferrer"
                        >
                            <Icon name="right" />
                        </a>
                    </div>
                </div>
            </section>
        );
    }
}

FileDownload.propTypes = {
    display_name: PropTypes.string,
    extension: PropTypes.string.isRequired,
    file: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    filesize: PropTypes.string.isRequired
};

export default FileDownload;
